// removed by extract-text-webpack-plugin
module.exports = {"gwGtpTitlePosition":"GuidanceOccupation-hashed__gwGtpTitlePosition__Ki879","gwGtpTextPosition":"GuidanceOccupation-hashed__gwGtpTextPosition__V3qCs","gwGtpTypeaheadContainer":"GuidanceOccupation-hashed__gwGtpTypeaheadContainer__3ewfw","gwGtpContinueButton":"GuidanceOccupation-hashed__gwGtpContinueButton__3VmsH"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/directives/Occupation/GuidanceOccupation-hashed.scss
// module id = 683
// module chunks = 0